import React, { useState } from 'react';
import axios from 'axios';
import './Conversation.css';

const Conversation = () => {
    const [loading, setLoading] = useState(false);
    const [conversationUrl, setConversationUrl] = useState('');
    const [errorMessage, setErrorMessage] = useState('');  // New state for error message


    // Hardcoded values for the API call
    const apiKey = '793ea847831343f887fa9ea9c78e59cd';  // Replace with your actual API key
    const replicaId = 'r3fbe3834a3e';  // Replace with your replica ID

    const joinConversation = async () => {
        setLoading(true);
        setErrorMessage('');  // Reset error message when starting the conversation


        // The hardcoded context and conversation details
        const body = {
            replica_id: replicaId,
            conversation_name: 'A Meeting on AI update for December 2024',  // Customize the conversation name
            conversational_context: `
            AI Update December 2024: Amazon Enters the Ring; OpenAI Embraces Defense
Amazon has released a new suite of LLMs called Amazon Nova. [1]
The models are designed to be competitive with offerings from Google and Anthropic. [1]
The most powerful model, Nova Premier, is still in training and is expected to be released in 2025. [2]
Initial impressions are that Nova is competitive with Google's Gemini family, particularly on price. [1]
Nova Micro is slightly cheaper than Gemini 1.5 Flash-8B. [1]
All Nova models except Micro can handle image, video and PDF input. [3]
Video support is currently limited to Nova and Gemini. [3]
Nova models cannot process audio. [3]
OpenAI’s GPT-4o was originally supposed to have image output but it was never released. [4]
Amazon has plans to release a speech-to-speech model and a model that can take and generate output in text, image, audio, and video. [4]
OpenAI has announced ChatGPT Pro, a $200/month subscription that provides unlimited access to their most advanced models, including o1 pro mode. [5, 6]
o1 pro mode utilizes increased computational power for enhanced reasoning and problem-solving capabilities. [5]
OpenAI is partnering with Anduril, a defense-tech company, to defend against drone attacks. [7, 8]
This represents a significant shift in OpenAI's policy, which at the beginning of the year explicitly banned the use of its models for military purposes. [7]
OpenAI now states that, in the right hands, AI could help protect people and even prevent future conflict. [7]
There are concerns that this work with the military could lead to increased civilian harm. [9]
Model Capabilities and Use Cases
Nova models can handle long context, with Mini handling up to 128,000 tokens and Lite and Pro up to 300,000 tokens. [10]
The models can be accessed through the command line using the llm-bedrock plugin, though obtaining AWS credentials with the necessary permissions is described as challenging. [10]
Examples are provided of Nova being used to generate creative text, summarize a complex PDF document, write code, and analyze images. [11-13]
Google has also released a video-generation AI, Veo. [14, 15]
Veo is the first hyperscaler to offer an image-to-video model. [16]
It empowers companies to create videos from text or image prompts, and is available on Vertex AI in private preview. [16, 17]
Google is also releasing Imagen 3, its highest quality image generation model to date. [15, 18]
Imagen 3 generates highly realistic images from text prompts and will be generally available on Vertex AI. [18]
Both Veo and Imagen 3 prioritize safety and responsibility, with features like digital watermarking and safety filters to help reduce the risk of harmful content. [19]
Industry Trends and Future Developments
AI-generated video is seen as an impressive technology but lacks consistency and can be easily identifiable as AI-generated. [20, 21]
There is optimism that video models will play an important role as world models in future AIs. [22]
Tencent, a Chinese corporation, has released Hunyuan, an open-source video-generation model. [14, 23]
Hunyuan is a compact (13 billion parameters) but powerful model that is comparable in performance to Runway’s GenAlpha3 or Luma AI 1.6. [14]
This release is viewed as a signal that China is committed to open-source AI development and is rapidly closing the gap with closed-source models from the US and Europe. [24]
Meta is exploring using nuclear energy to power its AI data centers. [24]
A study has found that 54% of long-form posts on LinkedIn are AI-generated, a 189% increase from late 2022. [25]
There is concern that AI-generated content is contributing to a decrease in quality and originality online. [26]
Anthropic has received a new $4 billion investment from Amazon, bringing the total investment from Amazon to $8 billion. [27]
This makes AWS Anthropic’s primary cloud and training partner. [27]
Anthropic is collaborating with Annapurna Labs at AWS to advance the capabilities of Trainium accelerators, specialized machine learning hardware. [28]
Anthropic is also working to make Claude models more secure and customizable through Amazon Bedrock. [29]
The use of AI for business purposes is expected to continue to increase dramatically. [30]
Vertical AI agents, which specialize in performing specific tasks within a particular industry, are predicted to be even more successful than SaaS companies. [30]
There is concern about the impact of AI on jobs, particularly in areas such as customer support, QA testing, and recruiting. [31, 32]
There are also potential benefits for managers and CEOs, as AI tools could help them manage larger and more complex organizations. [33]
Voice AI is rapidly improving and is now able to realistically replace humans in tasks such as debt collection. [34]
            `,  // Hardcoded context
            custom_greeting: 'Hey there, long time no see!',  // Optional greeting
        };

        try {
            const response = await axios.post('https://tavusapi.com/v2/conversations', body, {
                headers: {
                    'x-api-key': apiKey,
                    'Content-Type': 'application/json',
                },
            });

            // Extract the conversation URL from the response
            const url = response.data.conversation_url;
            setConversationUrl(url);
            setLoading(false);

            // Open the link directly using the URL from the response
            if (url) {
                window.open(url, '_blank', 'noopener,noreferrer');
            }

        } catch (error) {
            console.error('Error creating the conversation:', error);

            // Handle 400 error (Server is busy)
            if (error.response && error.response.status === 400) {
                setErrorMessage('Santa is busy talking to others. Please try again later...');
            } else {
                setErrorMessage('An unexpected error occurred. Please try again.');
            }

            setLoading(false);
        }
    };

    return (
        <div className="container">
            <h2>You can begin with the following questions:</h2>
            <div className="context">

                <ul>
                    <li>What's the latest buzz in the AI world?</li>
                    <li>What's up with China and AI these days?</li>
                    <li>Are there any concerns about AI being used for the military?</li>
                    <li>What's going on with OpenAI? Any cool new stuff?</li>
                    <li>How are large companies like Meta and Amazon addressing the energy demands of AI development?</li>
                </ul>

            </div>
            <div className="actions">
                {!conversationUrl ? (
                    <button onClick={joinConversation} disabled={loading}> 
                        {loading ? 'Creating Conversation...' : 'Lets get started !'} 
                    </button>
                ) : errorMessage ? (
                    <div className="error-message">{errorMessage}</div> // display error message for multiple conversations at same time
                ) : (
                    <p>The conversation has opened in a new tab. If it didn’t, <a href={conversationUrl} target="_blank" rel="noopener noreferrer">click here</a>.</p>
                )}
            </div>
        </div>
    );
};

export default Conversation;
